import DrugUpsertModalContainer from './drug-upsert-modal-container';

export default DrugUpsertModalContainer;
